export const routerParams = {
    SessionId: "mysessionid",
    RedirectUrl: "q"
};
